module.exports = __webpack_public_path__ + "img/money-blue.20c9de2b.svg";